module.exports = __webpack_public_path__ + "static/media/avatar_profile_finish.c083c03f.png";